import { useState } from 'react';
import './TransporterModal.scss';
import './RemarksModal.scss';

const RemarksModal = ({ visible, title, onClose, onConfirm }) => {
    const [remarks, setRemarks] = useState('');

    if (!visible) return null;

    const handleConfirm = () => {
        onConfirm(remarks);
        setRemarks('');
    };

    const handleClose = () => {
        setRemarks('');
        onClose();
    };

    return (
        <div className="modal-backdrop">
            <div className="modal-card remarks-modal-card">
                <button className="modal-close" onClick={handleClose}>×</button>

                <h3>{title}</h3>

                <div className="remarks-field">
                    <label>Remarks</label>
                    <textarea
                        rows={4}
                        placeholder="Enter remarks..."
                        value={remarks}
                        onChange={(e) => setRemarks(e.target.value)}
                    />
                </div>

                <div className="remarks-footer">
                    <button className="cancel-btn" onClick={handleClose}>Cancel</button>
                    <button className="confirm-btn" onClick={handleConfirm} disabled={!remarks.trim()}>
                        Confirm
                    </button>
                </div>
            </div>
        </div>
    );
};

export default RemarksModal;
